<template>
  <span style="font-size: 13px;margin-top: 50px">Upays Error System</span>
  <h1>{{errorNumber}}</h1>
  <h2>{{ errorMsg}}</h2>
  <button @click="supportMee"><i class="fa fa-envelope" aria-hidden="true"></i> Contact Support</button>
</template>
<script>
export default {
  name: '403',
  data() {
    return {
      errorMsg:'Unauthorized Access',
      errorNumber:'403',
    }
  },
  mounted() {
    window.scroll(0,0)
    this.emitter.emit('heroku', {'eventContent': '1'})
    let error = this.$route.path.split('/')
    this.errorNumber = error[1]
    switch(this.errorNumber) {
      case '404': this.errorMsg = 'Resource Not Found';break
      case '403': this.errorMsg = 'Unauthorized Access';break
      case '401': this.errorMsg = 'Unauthorized Request';break
      case '500': this.errorMsg = 'Internal Server Error';break
      case '503': this.errorMsg = 'Service Unavailable';break
      case 'sso': this.errorMsg = 'Browser Reload Unavailable';break
      case '400': this.errorMsg = 'Hsso Request Error';break
      case '402': this.errorMsg = 'Error creating web resource link - duplicate';break
      case '405': this.errorMsg = 'Query DB error';break
      default: this.errorMsg = 'Unclear error';break
    }
  },
  methods:{
    supportMee() {
      window.location.href = "mailto:?to=dnan66@gmail.com&subject=Support UpayS &body=Hello!"
    }
  }
}
</script>
<style >

</style>